(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabFirmwareDetailController', TabFirmwareDetailController);

    TabFirmwareDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TabFirmware', 'DataUtils'];

    function TabFirmwareDetailController($scope, $rootScope, $stateParams, entity, TabFirmware, DataUtils) {
        var vm = this;
        vm.tabFirmware = entity;
        vm.openFile = false;
        vm.fileContent = '';
        vm.tabFirmware.$promise.then(function(test){
            vm.firmwareBody = window.atob(vm.tabFirmware.firmwareBody);
        });

        var unsubscribe = $rootScope.$on('jotApp:tabFirmwareUpdate', function (event, result) {
            vm.tabFirmware = result;
        });
        
        $scope.$on('$destroy', unsubscribe);
        vm.byteSize = DataUtils.byteSize;
        // vm.openFile = DataUtils.openFile;
    }
})();
